import React, { useState } from "react";
import { Link } from "react-router-dom";
import { User, Send, ArrowLeft, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

export default function ForgotPassword() {
    const [username, setUsername] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await api.post("/admin/forgot-password", { username: username.trim().toLowerCase() });
            setDone(true);
        } catch {
            toast.error("Errore durante la richiesta. Riprova più tardi.");
        } finally {
            setSubmitting(false);
        }
    };

    if (done) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-ink px-6 grain pt-24" data-testid="forgot-password-success">
                <div className="max-w-md w-full bg-white/5 backdrop-blur-md border border-emerald-500/30 rounded-sm p-8 text-center">
                    <CheckCircle2 size={36} className="mx-auto text-emerald-300 mb-4" />
                    <h2 className="font-serif text-2xl text-white mb-2">Email inviata</h2>
                    <p className="text-gray-400 text-sm leading-relaxed">
                        Se l'username esiste, riceverai a breve una email con il link per reimpostare la password.<br />
                        Il link è valido per <strong className="text-white">1 ora</strong>.
                    </p>
                    <Link to="/admin/login" className="inline-flex items-center gap-2 mt-6 text-gold hover:text-gold-light text-xs tracking-widest uppercase">
                        <ArrowLeft size={14} /> Torna al login
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-ink px-6 grain pt-24" data-testid="forgot-password-page">
            <form onSubmit={submit} className="max-w-md w-full bg-white/5 backdrop-blur-md border border-white/10 rounded-sm p-8">
                <Link to="/admin/login" className="inline-flex items-center gap-2 text-gold hover:text-gold-light text-xs tracking-widest uppercase mb-5">
                    <ArrowLeft size={14} /> Torna al login
                </Link>
                <div className="text-gold text-xs tracking-[0.4em] uppercase">Recupero password</div>
                <h2 className="font-serif text-3xl text-white mt-2">Hai dimenticato la password?</h2>
                <p className="text-gray-400 text-sm mt-3">
                    Inserisci il tuo username: ti invieremo un link via email per reimpostare la password.
                </p>

                <div className="mt-6">
                    <label className="block text-[10px] uppercase tracking-[0.3em] text-gray-400 mb-1.5">Username</label>
                    <div className="relative">
                        <User className="absolute left-3 top-3 text-gold/70" size={16} strokeWidth={1.5} />
                        <input
                            type="text" required minLength={3}
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            data-testid="forgot-username"
                            className="w-full pl-10 pr-3 py-3 bg-transparent border border-white/15 rounded-sm text-white focus:border-gold focus:outline-none focus:ring-1 focus:ring-gold text-sm"
                        />
                    </div>
                </div>

                <button type="submit" disabled={submitting}
                    data-testid="forgot-submit"
                    className="w-full mt-6 inline-flex items-center justify-center gap-2 bg-gold text-black font-semibold px-6 py-3.5 rounded-sm hover:bg-gold-light transition-colors tracking-widest uppercase text-sm disabled:opacity-40">
                    {submitting ? "Invio in corso..." : <>Invia link di reset <Send size={14} /></>}
                </button>
            </form>
        </div>
    );
}
